import { ShaderNSlizgacz } from '../shaders/legs/shader_n_slizgacz';
import { ShaderNBox } from '../shaders/legs/shader_n_box';
import { ShaderNOkragla } from '../shaders/legs/shader_n_okagla';
import { ShaderNPlozy } from '../shaders/legs/shader_n_plozy';
import { ShaderNStBox } from '../shaders/legs/shader_n_st_box';
import { ShaderNStGiety } from '../shaders/legs/shader_n_st_giety';
import { ShaderNStProsta } from '../shaders/legs/shader_n_st_prosta';
import { ShaderNStPrzesun } from '../shaders/legs/shader_n_st_przesun';
import { ShaderNStScieta } from '../shaders/legs/shader_n_st_scieta';
import { ShaderNStStozek } from '../shaders/legs/shader_n_st_stozek';
import { ShaderNStozek } from '../shaders/legs/shader_n_stozek';
import { ShaderNWalec } from '../shaders/legs/shader_n_walec';
import { Legs } from './legs';
import { ProductType } from '@/store/modules/product';

export const chestFurnitureLegs = [
    new Legs(
        `n_slizgacz_{w}x{d}.gltf`,
        `n_slizgacz_{w}x{d}_light.jpg`,
        new ShaderNSlizgacz(),
        0,
        ProductType.CHEST_FURNITURE,
        'slizgacz_icon.jpg',
        20,
    ),
    new Legs(
        `n_box_{w}x{d}.gltf`,
        `n_box_{w}x{d}_light.jpg`,
        new ShaderNBox(),
        1,
        ProductType.CHEST_FURNITURE,
        'noga_prosta_debowa_icon.jpg',
        100,
    ),
    new Legs(
        `n_okragla_{w}x{d}.gltf`,
        `n_okragla_{w}x{d}_light.jpg`,
        new ShaderNOkragla(),
        2,
        ProductType.CHEST_FURNITURE,
        'noga_metalowa_icon.jpg',
        150,
    ),
    new Legs(
        `n_plozy_{w}x{d}.gltf`,
        `n_plozy_{w}x{d}_light.jpg`,
        new ShaderNPlozy(),
        1,
        ProductType.CHEST_FURNITURE,
        'ploza_metalowa_icon.jpg',
        100,
    ),
    new Legs(
        `n_st_box_{w}x{d}.gltf`,
        `n_st_box_{w}x{d}_light.jpg`,
        new ShaderNStBox(),
        2,
        ProductType.CHEST_FURNITURE,
        'stelaz_skosny_drewniany_icon.jpg',
        150,
    ),
    new Legs(
        `n_st_giety_{w}x{d}.gltf`,
        `n_st_giety_{w}x{d}_light.jpg`,
        new ShaderNStGiety(),
        1,
        ProductType.CHEST_FURNITURE,
        'stelaz_giety_metalowy_icon.jpg',
        100,
    ),
    new Legs(
        `n_st_prosta_{w}x{d}.gltf`,
        `n_st_prosta_{w}x{d}_light.jpg`,
        new ShaderNStProsta(),
        2,
        ProductType.CHEST_FURNITURE,
        'stelaz_prosty_metalowy_icon.jpg',
        150,
    ),
    new Legs(
        `n_st_przesun_{w}x{d}.gltf`,
        `n_st_przesun_{w}x{d}_light.jpg`,
        new ShaderNStPrzesun(),
        3,
        ProductType.CHEST_FURNITURE,
        'stelaz_skosny_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `n_st_scieta_{w}x{d}.gltf`,
        `n_st_scieta_{w}x{d}_light.jpg`,
        new ShaderNStScieta(),
        3,
        ProductType.CHEST_FURNITURE,
        'stelaz_skosny_debowy_icon.jpg',
        200,
    ),
    new Legs(
        `n_st_stozek_{w}x{d}.gltf`,
        `n_st_stozek_{w}x{d}_light.jpg`,
        new ShaderNStStozek(),
        2,
        ProductType.CHEST_FURNITURE,
        'stelaz_skosny_drewniany_stozek_icon.jpg',
        150,
    ),
    new Legs(
        `n_stozek_{w}x{d}.gltf`,
        `n_stozek_{w}x{d}_light.jpg`,
        new ShaderNStozek(),
        2,
        ProductType.CHEST_FURNITURE,
        'noga_stozek_drewniana_icon.jpg',
        150,
    ),
    new Legs(
        `n_walec_{w}x{d}.gltf`,
        `n_walec_{w}x{d}_light.jpg`,
        new ShaderNWalec(),
        1,
        ProductType.CHEST_FURNITURE,
        'noga_walec_debowa_icon.jpg',
        100,
    ),
];
